import styled from "styled-components";
import {
	Accordion,
	AccordionDetails as MUIAccordionDetails,
	AccordionSummary as MUIAccordionSummary,
} from "@mui/material";
import { SpinnerLoading } from "../styles";

export const ContainerAccordion = styled(Accordion)`
	&&& {
		background: ${({ theme }) => theme.grayLight};
		padding: 0.6rem 0;

		/* When is Expanded */
		&.MuiAccordion-root.Mui-expanded {
			margin: inherit;
		}

		.MuiSvgIcon-root {
			color: ${({ theme }) => theme.pantone2727C};
		}
	}
`;

export const AccordionSummary = styled(MUIAccordionSummary)`
	&&& {
		background: ${({ theme }) => theme.grayLight};
		.MuiAccordionSummary-content > * {
			margin: 0;
		}

		span {
			color: ${({ theme }) => theme.black};
		}
	}
`;

export const AccordionDetails = styled(MUIAccordionDetails)`
	&&& {
		display: flex;
		flex-direction: column;
		background: ${({ theme }) => theme.grayLight};
		overflow-y: auto;
		padding: 0 8px;

		${SpinnerLoading} {
			margin: 0.4rem auto;
		}
	}
`;
